import { Component, OnInit } from '@angular/core';
import { AppFrameContextService } from '@sdbn/common';
import { DialogService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AccountInfoService } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { Catalog } from '../../catalog.model';
import { AddCatalogDialogComponent } from '../add-catalog-dialog/add-catalog-dialog.component';
import { AddCatalogNodeDialogComponent } from '../add-catalog-node-dialog/add-catalog-node-dialog.component';

@Component({
  selector: 'app-catalog-admin',
  templateUrl: './catalog-admin.component.html',
  styleUrls: ['./catalog-admin.component.scss']
})
export class CatalogAdminComponent extends AbstractWidgetComponent implements OnInit {

  articleSearchListEntry = new Catalog({name: {dictionaryKey: 'Search', values: [{language: 'de', value: 'Suche'}, {language: 'en', value: 'Search'}, {language: 'fr', value: 'Search'}, {language: 'it', value: 'Search'}]}});
  data = new Array<Catalog>();

  selected: Catalog;
  selectedId: number;

  manageCatalogPermitted = false;

  constructor(
    private accountInfoService: AccountInfoService,
    private appFrameContextService: AppFrameContextService,
    public translationService: TranslationService,
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI
  ) {

    super();

  }

  ngOnInit(): void {
    this.translationService.changed.subscribe(newLanguage => {
      this.data.forEach(catalog => {
        catalog.calculateTitle(this.translationService.language);
      });
    });
    if (this.checkUserHasPrivilegeManageCatalog()) {
      this.manageCatalogPermitted = true;
      this.articleSearchListEntry.calculateTitle(this.translationService.language);
      this.readCatalogData();
    } else {
      this.dialogService.showInfoDialog('shared.tmc-http-interceptor.error.403.title',
          'shared.tmc-http-interceptor.error.403.message');
    }


  }

  public readCatalogData() {

    this.selectedId = this.selected != null ? this.selected?.id : null;

    this.appServerAPI.execute<Catalog[]>('/client/erp-article/catalog/getAllCatalogs', {}).subscribe(response => {
      console.log('response is', response);

      let data = new Array<Catalog>();

      data.push(this.articleSearchListEntry);

      for (let catalog of response) {
        const c = new Catalog(catalog);
        c.calculateTitle(this.translationService.language);
        data.push(c);
      }
      this.data = data;

      this.restoreSelection();

      console.log(data);

    }, error => {
      console.log('error is', error);
    });

  }

  restoreSelection() {
    let selected: Catalog = null;

    if (this.selectedId != null) {
      for (let catalog of this.data) {
        if (catalog.id === this.selectedId) {
          selected = catalog;
        }
      }
    }

    if (selected == null && this.data.length > 0) {
      selected = this.data[0];
    }

    this.selected = selected;
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.selected = entry as Catalog;
  }

  onAddEntry(value: any) {
    console.log(value);
    this.dialogService.openDefault(AddCatalogDialogComponent, {}).afterClosed(

    ).subscribe(() => {

      this.readCatalogData();

    });
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    if (entry === this.articleSearchListEntry) {
      return;
    }
    const dialogRef = this.dialogService.showConfirm('erp.ui.delete-catalog.title', 'erp.ui.delete-catalog.message');
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed === true) {
        this.appServerAPI.execute<Catalog[]>('/client/erp-article/catalog/deleteCatalog', {catalogId: this.selected.id}).subscribe(response => {
          console.log('deleteCatalog response is', response);
          this.readCatalogData();
        });
      }
    });
  }

  addRootNode() {
    this.dialogService.openDefault(AddCatalogNodeDialogComponent, { catalogId: this.selected.id, parentNodeId: null }).afterClosed(

    ).subscribe(() => {

      this.readCatalogData();

    });
  }


  private checkUserHasPrivilegeManageCatalog(): boolean {
    const yardKey = this.appFrameContextService.tenant.value?.key;
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'erp.manage-basicarticle');
  }

}
